import * as React from 'react'
import { MapMarkerIcon } from '../../icons/MapMarkerIcon'
import { css, styled } from '../../../theme/styled'
import { MapPinIcon } from '../../icons/MapPinIcon'
import { Property } from '../interfaces'
import MapPopover from './MapPopover'

const scaleStyle = css`
  transform: scale(1.3);
  transform-origin: bottom center;
  z-index: 1;
`

type StyledMapPinProps = {
  $hover: boolean
  $isActive: boolean
  $isSubjectProperty?: boolean
}
const StyledMapPin = styled.div<StyledMapPinProps>`
  width: 48px;
  height: 48px;

  transition: all ease-out 200ms;
  left: -20.5px;
  top: -32px;
  position: absolute;
  ${(p) => p.$hover && scaleStyle}
  cursor: pointer;
`

const MapMarker = (
  props: {
    $hover?: boolean
    isActive: boolean
    highlight?: boolean
    lat: number
    lng: number
    propertyData: Property['propertyData']
    isSubjectProperty?: boolean
    onPopoverClick?: (id: string) => void
    getMapMarkerColor?: (propertyData: Property['propertyData']) => string
  } & React.HTMLAttributes<HTMLOrSVGElement>
) => {
  const { highlight, isActive, $hover, propertyData, isSubjectProperty, onPopoverClick } = props

  const propsCopy: any = { ...props }
  Object.keys(propsCopy)
    .filter((x) => x.startsWith('$'))
    .forEach((x) => delete propsCopy[x])

  const shouldShowDialog = isActive
  return (
    <React.Fragment>
      {shouldShowDialog && propertyData && (
        <MapPopover
          property={propertyData}
          onClick={() => onPopoverClick?.(String(propertyData.id))}
        />
      )}
      <StyledMapPin $hover={highlight || $hover || isActive} $isActive={isActive}>
        {isSubjectProperty ? <MapPinIcon /> : <MapMarkerIcon color={props.color} />}
      </StyledMapPin>
    </React.Fragment>
  )
}

export default MapMarker
